import { IModel } from 'interfaces/model.interface'
import { ValueType } from 'interfaces/valueType.interface'

import { SortOrders } from 'enums/SortOrders'

import Tag from '../../tagColours/Tag'
import Topic from '../../tagColours/Topic'

export type IDTreatments360MediaData =
  | 'microlink'
  | 'title'
  | 'source'
  | 'afTopic'
  | 'datePublished'
  | 'description'
  | 'link'
  | 'vaccine'
  | 'author'
  | 'companyResearchInstitution'
  | 'afTags'
  | 'language'
  | 'afProject'
  | 'published'
  | 'company'
  | 'luCompany'
  | 'linkInfectiousDisease'
  | 'afProjectSubtype'
  | 'candidateNumber'
  | 'typeOfPathogenFromLinkInfectiousDisease'
  | 'niaidPathogenFromLinkInfectiousDisease'

const allowedAirtables = [
  'api_app_PAD_all',
  'api_app_PAD_Coronaviridae',
  'api_app_PAD_Paramyxoviridae',
  'api_app_PAD_Orthomyxoviridae',
] as const

export const IDTreatments360MediaModel: IModel<
  Record<IDTreatments360MediaData, string>,
  typeof allowedAirtables
> = {
  allowedAirtables,
  displayKey: 'title',
  name: 'Media',
  entityName: 'News',
  searchField: 'title',
  endpoint: 'media',
  defaultSortKey: 'datePublished',
  defaultSortOrder: SortOrders.DESC,
  detailViewType: 'Article',
  exportDisabled: true,
  detailView: {
    link: 'link',
    abstract: 'description',
  },
  noPrint: true,
  schema: {
    columns: [
      {
        key: 'microlink',
        label: 'Microlink',
        type: ValueType.TEXT,
        width: 200,
      },
      {
        key: 'title',
        width: 500,
        showDetail: false,
        cellFormat: {
          maxLines: 3,
        },
      },
      {
        key: 'source',
        type: ValueType.SINGLE,
        width: 160,
        label: 'Media Provider',
      },
      {
        key: 'afTopic',
        type: ValueType.SINGLE,
        label: 'Topic',
        width: 200,
        graphType: 'Bar',
        cellFormat: {
          colours: Topic,
        },
      },
      {
        key: 'datePublished',
        type: ValueType.DATE,
        label: 'Publication date',
        width: 120,
      },
      {
        key: 'description',
        width: 600,
        detailType: 'LONG',
        showTable: false,
        label: 'Summary',
      },
      { key: 'link', type: ValueType.URL, label: 'Link', width: 120 },
      { key: 'vaccine', label: 'Treatment', type: ValueType.MULTI, width: 200 },
      {
        key: 'author',
        type: ValueType.MULTI,
        label: 'Authors',
        width: 200,
        customDataFilter: (data) => {
          return data?.filter((dataItem) => dataItem.author !== null)
        },
      },
      {
        key: 'companyResearchInstitution',
        label: 'Company Research Institution',
        type: ValueType.MULTI,
        width: 270,
        graphType: 'Pie',
      },
      {
        key: 'afTags',
        label: 'Tags',
        type: ValueType.MULTI,
        width: 260,
        cellFormat: {
          colours: Tag,
        },
      },
      {
        key: 'language',
        width: 100,
        type: ValueType.SINGLE,
        label: 'Language',
        graphType: 'Bar',
      },
      { key: 'afProject', label: 'Project', type: ValueType.MULTI, width: 200 },
      {
        key: 'published',
        label: 'Published',
        width: 150,
        type: ValueType.TEXT,
      },
      { key: 'company', label: 'Company', width: 200, type: ValueType.MULTI },
      {
        key: 'luCompany',
        label: 'Company',
        type: ValueType.MULTI,
        width: 200,
      },
      {
        key: 'linkInfectiousDisease',
        label: 'Infectious Disease',
        width: 130,
        type: ValueType.MULTI,
      },
      {
        key: 'afProjectSubtype',
        label: 'Project Subtype',
        type: ValueType.MULTI,
        width: 200,
      },
      {
        key: 'candidateNumber',
        label: 'Candidate Number',
        type: ValueType.MULTI,
        width: 200,
      },
      {
        key: 'typeOfPathogenFromLinkInfectiousDisease',
        label: 'Type Of Pathogen',
        type: ValueType.MULTI,
        width: 150,
      },
      {
        key: 'niaidPathogenFromLinkInfectiousDisease',
        label: 'Viral Family',
        type: ValueType.MULTI,
        width: 150,
      },
    ],
  },
}
